import type { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { Api, clearTokens, queryClient, queryKeys, storage } from '@frontend/shared';

import { constants } from '../../constants';

let _extranetApi: Api | null = null;

const getFreshTokens = async (): Promise<string | null> => {
  const fromCache = queryClient.getQueryData<LoginOutput>(queryKeys.tokens());
  if (fromCache?.accessToken) {
    return fromCache.accessToken;
  }
  const fromStorage = storage.getJSONItem<LoginOutput>('tokens');
  return fromStorage?.accessToken ?? null;
};

/**
 * Sur extranet, `INVALID_USER_TYPE` = "l'utilisateur connecté n'a pas la
 * permission requise pour cet endpoint" (ex. `EXTRANET_ADMIN` sur les routes
 * admin). Ce n'est PAS un signal d'invalidité du token — le check de type
 * global se fait au login (X-Client-Type: extranet). On ne clear donc que sur
 * `INVALID_TOKEN` (token expiré / révoqué) et on laisse les 403 fonctionnels
 * masquer les modules concernés côté UI.
 */
export const getExtranetApi = (): Api => {
  if (!_extranetApi) {
    _extranetApi = new Api(constants.extranetApi || '', getFreshTokens, reason => {
      if (reason === 'INVALID_USER_TYPE') {
        // Trace dev-only : aide au diagnostic si une nouvelle route back gate
        // fonctionnellement l'utilisateur. En prod, silencieux (le UI dégrade
        // via `query.isError` + `TableErrorRow` / toast).
        if (constants.isLocal) console.debug('[extranet] INVALID_USER_TYPE ignoré (403 fonctionnel)');
        return;
      }
      clearTokens(queryClient);
    });
  }
  return _extranetApi;
};
